var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C12.1989 1.5 12.3896 1.57902 12.5303 1.71967C12.671 1.86032 12.75 2.05109 12.75 2.25V19.9395L17.469 15.219C17.6098 15.0782 17.8008 14.9991 18 14.9991C18.1991 14.9991 18.3901 15.0782 18.531 15.219C18.6718 15.3598 18.7509 15.5508 18.7509 15.75C18.7509 15.9492 18.6718 16.1402 18.531 16.281L12.531 22.281C12.4613 22.3508 12.3785 22.4063 12.2874 22.4441C12.1963 22.4819 12.0986 22.5013 12 22.5013C11.9013 22.5013 11.8036 22.4819 11.7125 22.4441C11.6214 22.4063 11.5386 22.3508 11.469 22.281L5.46897 16.281C5.32814 16.1402 5.24902 15.9492 5.24902 15.75C5.24902 15.5508 5.32814 15.3598 5.46897 15.219C5.6098 15.0782 5.80081 14.9991 5.99997 14.9991C6.19913 14.9991 6.39014 15.0782 6.53097 15.219L11.25 19.9395V2.25C11.25 2.05109 11.329 1.86032 11.4696 1.71967C11.6103 1.57902 11.8011 1.5 12 1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsArrowDown);
export default __webpack_public_path__ + "static/media/bsArrowDown.900426dc546906353d62abdd19adf314.svg";
export { ForwardRef as ReactComponent };